var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "GoogleG_FullColor_rgb",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4285f4;}.cls-2{fill:#34a853;}.cls-3{fill:#fabb05;}.cls-4{fill:#e94235;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "GoogleG_FullColor_rgb_64px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_64px",
    "data-name": "64px"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63,32.73A37.6,37.6,0,0,0,62.39,26H32V39H50c-.73,4.08-3.34,7-6.79,9.37v7.91H53.44C59.51,50.7,63,42.47,63,32.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.14,64c8.67,0,16-2.84,21.3-7.72L43.21,48.37A19.65,19.65,0,0,1,14,38.22H3.42v8.15A32.16,32.16,0,0,0,32.14,64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M14,38.22a18.95,18.95,0,0,1,0-12.44V17.63H3.42a31.9,31.9,0,0,0,0,28.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M32.14,12.5a17.67,17.67,0,0,1,12.44,4.84l9.06-9A30.92,30.92,0,0,0,32.14,0,32.16,32.16,0,0,0,3.42,17.63L14,25.78A19.36,19.36,0,0,1,32.14,12.5Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.34a8aab1cbd4e60922ed3803c8e11a96.svg";
export { ForwardRef as ReactComponent };